import { useState } from 'react'
import { MdClose } from 'react-icons/md'
import ConfirmDeleteMineralCountry from './ConfirmDeleteMineralCountry'

export default function ButtonDeleteMineralCountry({
  mineralId,
  countryId,
  fetchCountries,
}) {
  const [isOpen, setIsOpen] = useState(false)

  function handleOnOpenModel() {
    setIsOpen(true)
  }

  function handleOnCloseModel() {
    setIsOpen(false)
  }

  return (
    <>
      <button
        onClick={handleOnOpenModel}
        className="flex border-2 border-danger-500 bg-danger-300 p-1 text-white hover:bg-danger-500"
      >
        <MdClose size={22} />
      </button>
      <ConfirmDeleteMineralCountry
        isOpen={isOpen}
        onClose={handleOnCloseModel}
        mineralId={mineralId}
        countryId={countryId}
        fetchCountries={fetchCountries}
      />
    </>
  )
}
